/**
 * LanguageSwitcher Component
 * A language selector that displays "En" or "Ar" based on the selected language
 */
import { Select, MenuItem, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useUIStore } from "../../../store";
import { styles } from "./LanguageSwitcher.styles";

const LanguageSwitcher = ({ collapsed = false }) => {
    const { i18n } = useTranslation();
    const language = useUIStore((state) => state.language);
    const setLanguage = useUIStore((state) => state.setLanguage);

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        setLanguage(lang);
    };

    return (
        <Select
            value={language}
            onChange={(e) => handleLanguageChange(e.target.value)}
            size="small"
            variant="outlined"
            sx={styles.select(collapsed)}
            renderValue={(lang) => (lang === "en" ? "En" : "ع")}
            MenuProps={{
                PaperProps: {
                    sx: styles.menuPaper,
                },
            }}
        >
            <MenuItem value="en" sx={styles.menuItem}>
                <Box sx={styles.menuItemContent}>
                    <Box sx={language === "en" ? styles.bulletFilled : styles.bulletOutlined}>●</Box>
                    <Box>English</Box>
                </Box>
            </MenuItem>
            <MenuItem value="ar" sx={styles.menuItem}>
                <Box sx={styles.menuItemContent}>
                    <Box sx={language === "ar" ? styles.bulletFilled : styles.bulletOutlined}>●</Box>
                    <Box>العربية</Box>
                </Box>
            </MenuItem>
        </Select>
    );
};

LanguageSwitcher.propTypes = {
    collapsed: PropTypes.bool,
};

export default LanguageSwitcher;
